import { PageController } from '@client/components/_core/layout/PageController';
import { preloadMarkdownRenderer } from '@client/components/_ui/display/Markdown';
import { PdsDocumentEditPage } from '@client/components/market-pds/PdsDocumentEditPage';
import type { ShareableRouteContext } from '@client/types/router';
import { createFileRoute } from '@tanstack/react-router';
import { FileText } from 'lucide-react';

export const Route = createFileRoute('/console/$orgId/tools/pds-compare/pds-documents/edit/$id')({
    params: {
        parse({ id }) {
            return { id };
        },
    },
    staticData: {
        presentation: 'fullPage',
        ui: {
            icon: FileText,
            widthVariant: 'default',
        },
    },
    beforeLoad({ context: { trpcUtils }, params }): ShareableRouteContext {
        async function title() {
            const pds = await trpcUtils.marketPds.getOrgPds.ensureData({ id: BigInt(params.id) });
            const name = pds?.name || 'Edit PDS';
            return (
                <span className="inline-block max-w-md truncate align-bottom" title={name}>
                    {name}
                </span>
            );
        }
        return {
            breadcrumb: { title: 'Edit PDS' },
            ui: { title, subtitle: 'View and edit PDS details' },
        };
    },
    // Wait for the Markdown renderer so the raw text tab shows formatted output on first view.
    loader: preloadMarkdownRenderer,
    component: RouteComponent,
});

function RouteComponent() {
    const { id } = Route.useParams();

    return (
        <PageController route={Route}>
            <PdsDocumentEditPage scope="org" id={BigInt(id)} />
        </PageController>
    );
}
